import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material';

import { MarketWidgetSkeleton } from '@/pages/Markets/MarketsSkeleton/MarketWidgetSkeleton';

const labelSx = { my: 5 };
const paperSx = { py: 2, px: 3, width: '100%', height: 56 };
const stackSx = { width: '100%', mt: 3, flexWrap: 'wrap' };

const MarketsSkeleton = () => (
  <Box data-testid='markets-skeleton'>
    <Typography sx={labelSx}>Loading your data, please wait...</Typography>
    <Paper sx={paperSx}>
      <Skeleton width='25%' />
    </Paper>
    <Stack
      useFlexGap
      direction='row'
      spacing={3}
      sx={stackSx}
    >
      {[0, 1, 2, 3, 4, 5].map(paper => (
        <MarketWidgetSkeleton key={paper} />
      ))}
    </Stack>
  </Box>
);

export default MarketsSkeleton;
